import { UPDATE_LOCAL_SERVER_TIME_GAP } from 'store/mutation-types'

const state = {
  localServerTimeGap: 0,
  serverTime: 0
}

const mutations = {
  [UPDATE_LOCAL_SERVER_TIME_GAP](state, serverTimestamp) {
    state.serverTime = serverTimestamp
    state.localServerTimeGap = new Date().getTime() - serverTimestamp
  }
}

const actions = {
  updateTime({ commit }, serverTimestamp) {
    commit(UPDATE_LOCAL_SERVER_TIME_GAP, serverTimestamp)
  }
}

export default { state, mutations, actions }
